import { render } from "./OrnekOnizleme.vue?vue&type=template&id=c24e8144"
import script from "./OrnekOnizleme.vue?vue&type=script&lang=js"
export * from "./OrnekOnizleme.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__